import ServiceInvoiceImg from "@/assets/service invoice.jpg";
import CollectionReceipt from "@/assets/collection_receipt.jpg";
import ServiceInvoiceNew from "@/assets/service invoice-new.jpg";
import AcknowledmentReceipt from "@/assets/Acknowledgement Receipt.png";

export const invoiceTemplates = {
    Service_Invoice_1: {
        image: ServiceInvoiceImg,

        size: {
            width: 643,
            height: 756,
        },

        fields: {
            soldTo: {
                x: 149,
                y: 146,
            },

            tin: {
                x: 150,
                y: 160,
            },

            address: {
                x: 150,
                y: 180,
            },

            date: {
                x: 500,
                y: 142,
            },

            itemDescription: {
                x: 170,
                y: 284,
            },

            amount: {
                x: 502,
                y: 290,
            },

            checkNo: {
                x: 85,
                y: 510,
            },

            bank: {
                x: 60,
                y: 530,
            },

            vatable: {
                x: 269,
                y: 472,
            },

            vatExempt: {
                x: 268,
                y: 492,
            },

            zeroRated: {
                x: 267,
                y: 514,
            },

            vatAmount: {
                x: 267,
                y: 536,
            },

            totalSalesVatInclusive: {
                x: 486,
                y: 449,
            },

            lessVat: {
                x: 487,
                y: 473,
            },

            netOfVat: {
                x: 485,
                y: 496,
            },

            scPwdDiscount: {
                x: 486,
                y: 518,
            },

            withholdingTax: {
                x: 486,
                y: 555,
            },

            totalDue: {
                x: 485,
                y: 574,
            },

            invoiceNumber: {
                x: 483,
                y: 710,
            },
        },
    },

    Service_Invoice_2: {
        image: ServiceInvoiceNew,

        size: {
            width: 631,
            height: 718,
        },

        fields: {
            soldTo: {
                x: 147.5,
                y: 151,

                baseTop: 170,
                useDynamicY: true,

                width: "250px",

                fontClass:
                    "text-xs break-all whitespace-normal",
            },

            tin: {
                x: 144,
                y: 189,
            },

            address: {
                x: 149,
                y: 207,

                width: "430px",
            },

            date: {
                x: 463,
                y: 168,
            },

            itemDescription: {
                x: 167,
                y: 275,
            },

            amount: {
                x: 493,
                y: 278,
            },

            checkNo: {
                x: 88,
                y: 525,
            },

            bank: {
                x: 62,
                y: 546,
            },

            vatable: {
                x: 268,
                y: 506,
            },

            vatExempt: {
                x: 268,
                y: 565,
            },

            zeroRated: {
                x: 269,
                y: 544,
            },

            vatAmount: {
                x: 268,
                y: 526,
            },

            totalSalesVatInclusive: {
                x: 474,
                y: 463,
            },

            lessVat: {
                x: 474,
                y: 487,
            },

            netOfVat: {
                x: 472,
                y: 507,
            },

            scPwdDiscount: {
                x: 473,
                y: 525,
            },

            withholdingTax: {
                x: 472,
                y: 564,
            },

            totalDue: {
                x: 472,
                y: 585,
            },

        },
    },

    Collection_Receipt: {
        image: CollectionReceipt,

        size: {
            width: 764,
            height: 389,
        },

        fields: {

            date: {
                x: 651,
                y: 123,
            },

            soldTo: {

                x: 369,
                y: 157,
                baseTop: 160,
                useDynamicY: true,

                width: "350px",

                fontClass:
                    "text-xs break-words whitespace-normal",
            },

            amountWord: {
                x: 376,
                y: 233,
            },

            totalAmountDue: {
                x: 268.5,
                y: 257.5,
            },

            address: {
                x: 267,
                y: 209,

                width: "480px",
            },

            itemDescription: {
                x: 566,
                y: 259,

                width: "190px",
                fontClass:
                    "text-[10px] break-words whitespace-normal",
            },

            tin: {
                x: 310, y: 184
            },

        },
    },

    Acknowledgement_Receipt: {
        image: AcknowledmentReceipt,

        size: {
            width: 766,
            height: 434.7,
        },

        fields: {
            soldTo: {
                x: 147,
                y: 178,

                baseTop: 184,
                useDynamicY: true,

                width: "470px",

                fontClass:
                    "text-xs break-words whitespace-normal leading-6",
            },

            address: {
                x: 138,
                y: 214,

                width: "500px",
            },

            itemDescription: {
                x: 253,
                y: 287,

                width: "430px",
            },

            date: {
                x: 582,
                y: 160,
            },

            amountWord: {
                x: 155,
                y: 239,
            },

            totalAmountDue: {
                x: 554,
                y: 262,
            },
        },
    },
};